module.exports = __webpack_public_path__ + "img/20190810114720QQ截图20190810015631.3b84b8f6.png";